import {useMutation, useQueryClient} from "react-query";
import {useFormik} from "formik";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {spaceIdState} from "../../state/spaceState";
import api from "../../services/api";
import accessTokenState from "../../state/accessTokenState";
import useTiming from "../useTiming";
import loggedOutState from "../../state/loggedOutState";

const loginMutation = ({timing, redeem, ...data}) => {
  if (redeem) {
    data['_method'] = 'patch';
  }

  const formData = new FormData();
  for (const key in data) {
      if(key === 'avatar') {
          if(data?.avatar instanceof File || data?.avatar === false) {
              formData.append('avatar', data.avatar ? data.avatar : '');
          }
      }
      else {
          formData.append(key, data[key]);
      }
  }

  return api
    .post(`/timings/${timing}/login`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(res => res?.data);
};

const useLogin = () => {
    const timing = useTiming();
    const setAccessToken = useSetRecoilState(accessTokenState);
    const setLoggedOut = useSetRecoilState(loggedOutState);

    const queryClient = useQueryClient();

    const mutation = useMutation(loginMutation, {
        onSuccess: ({data, access_token}) => {
            formik.resetForm();

            if(!data || !access_token) {
                return false;
            }

            api.updateToken(access_token);
            setLoggedOut(false);
            setAccessToken(access_token);

            // Assume we can view page because we logged in successfully
            queryClient.setQueryData(['valid', timing.id], {valid: true});
            // Update query data on react-query
            queryClient.setQueryData('user', data);

            return true;
        },
        onError: (e) => {
            if(e.response.status === 405) {
                formik.setFieldValue('redeem', true);
                formik.setFieldValue('name', e.response.data?.data?.name || '');
                formik.setFieldValue('email', e.response.data?.data?.email || '');
                formik.setFieldValue('company', e.response.data?.data?.company || '');
                formik.setFieldValue('phone', e.response.data?.data?.phone || '');
                formik.setFieldValue('phone_country', e.response.data?.data?.phone_country || "MY");
                formik.setFieldValue('location', e.response.data?.data?.location || '');
                formik.setFieldValue('remarks', e.response.data?.data?.remarks || '');

                return false;
            }
            if(e.response.status == 406) {
                queryClient.setQueryData(['valid', timing.id], true);
                queryClient.setQueryData('user', e.response?.data?.data);
                setLoggedOut(false);

                return true;
            }

            queryClient.removeQueries('user');

            return false;
        },
    });

    const formik = useFormik({
        initialValues: {
            code: '',
            redeem: false,
            avatar: false,
            name: '',
            email: '',
            company: '',
            phone_country: 'MY',
            phone: '',
            timing: timing?.id,
            location:'',
        },
        validate: (values) => {
            mutation.reset();

            const errors = {};

            return errors;
        },
        onSubmit: mutation.mutateAsync,
    });

    return {
        formik,
        mutation,
    };
};

export default useLogin;
